import humanizeDuration from 'humanize-duration';

/**
 * Formats a number of milliseconds to a human readable string
 *
 * @param millis - The number of milliseconds to format
 * @returns
 */
export const formatMillisecondsToAgeString = (millis: number): string =>
  `${humanizeDuration(Date.now() - millis, { largest: 1, maxDecimalPoints: 0 })} ago`;
